<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8 5H5.2C4.534 5 4 5.55625 4 6.25V13.75C4 14.0815 4.12643 14.3995 4.35147 14.6339C4.57652 14.8683 4.88174 15 5.2 15H14.8C15.1183 15 15.4235 14.8683 15.6485 14.6339C15.8736 14.3995 16 14.0815 16 13.75V7.5C16 6.80625 15.46 6.25 14.8 6.25H10L8.8 5Z" :fill="fill"/>
  </svg>


</template>

<script>
  export default {
    props: {
      fill: {
        type: String,
        required: false,
        default: '#00527F'
      }
    }
  }
</script>

